import vuetify from '@/plugins/vuetify.js';
export default {
  methods: {
    $_CMS_getLabelByHideLabelFields(fieldKey, fields, hideLabelFields) {
      if (!hideLabelFields) {
        return this.$_CMS_getFieldByFieldKey(fieldKey, fields).label;
      } else {
        if (hideLabelFields.indexOf(fieldKey) >= 0) {
          return null;
        } else {
          return this.$_CMS_getFieldByFieldKey(fieldKey, fields).label;
        }
      }
    },
    $_CMS_getFieldByFieldKey(fieldKey, fields) {
      const keyArr = fieldKey.split('.');
      let target = fields;
      for (let i = 0; i < keyArr.length; i++) {
        const keyItem = keyArr[i];
        if (i == 0) {
          if (target[keyItem] !== undefined) {
            target = target[keyItem];
          } else {
            return null;
          }
        } else {
          if (target.fields[keyItem] !== undefined) {
            target = target.fields[keyItem];
          } else {
            return null;
          }
        }
      }
      return target;
    },
    $_CMS_getVersionsFields(versionsFields, keyPre = '', labelPre = '') {
      let versions_fields = {};
      for (let versionsFieldKey in versionsFields) {
        const versionsField = versionsFields[versionsFieldKey];
        if (versionsField.type == 'locales') {
          versions_fields = {
            ...this.$_CMS_getLocalesFields(
              versionsField.fields,
              `${keyPre}last_version__`,
              '最新版本-',
            ),
            ...versions_fields,
          };
        } else {
          versions_fields[`${keyPre}last_version__${versionsFieldKey}`] = {
            ...versionsField,
            label: `${labelPre}最新版本-${versionsField.label}`,
            showOnly: true,
          };
        }
      }
      return versions_fields;
    },
    $_CMS_getPayloadsFields(payloadsFields, keyPre = '', labelPre = '') {
      let payloads_fields = {};
      for (let payloadsFieldKey in payloadsFields) {
        const payloadsField = payloadsFields[payloadsFieldKey];
        if (payloadsField.type == 'locales') {
          payloads_fields = {
            ...this.$_CMS_getLocalesFields(
              payloadsField.fields,
              `${keyPre}last_version__`,
              '最新版本-',
            ),
            ...payloads_fields,
          };
        } else if (payloadsField.type == 'last_version') {
          payloads_fields[`${keyPre}last_version__${payloadsFieldKey}`] = {
            ...payloadsField,
            label: `${labelPre}最新版本-${payloadsField.label}`,
            showOnly: true,
          };
        } else {
          payloads_fields[`${keyPre}payload__${payloadsFieldKey}`] = {
            ...payloadsField,
            label: `${labelPre}${payloadsField.label}`,
            showOnly: true,
          };
        }
      }
      return payloads_fields;
    },
    $_CMS_getFactorysFields(factorysFields, keyPre = '', labelPre = '') {
      let factorys_fields = {};
      for (let factorysFieldKey in factorysFields) {
        const factorysField = factorysFields[factorysFieldKey];
        if (factorysField.type == 'locales') {
          factorys_fields = {
            ...this.$_CMS_getLocalesFields(
              factorysField.fields,
              `${keyPre}last_version__`,
              '最新版本-',
            ),
            ...factorys_fields,
          };
        } else if (factorysField.type == 'last_version') {
          factorys_fields[`${keyPre}last_version__${factorysFieldKey}`] = {
            ...factorysField,
            label: `${labelPre}最新版本-${factorysField.label}`,
            showOnly: true,
          };
        } else {
          factorys_fields[`${keyPre}factory__${factorysFieldKey}`] = {
            ...factorysField,
            label: `${labelPre}${factorysField.label}`,
            showOnly: true,
          };
        }
      }
      return factorys_fields;
    },
    $_CMS_getAdminsFields(adminsFields, keyPre = '', labelPre = '') {
      let admins_fields = {};
      for (let adminsFieldKey in adminsFields) {
        const adminsField = adminsFields[adminsFieldKey];
        if (adminsField.type == 'locales') {
          admins_fields = {
            ...this.$_CMS_getLocalesFields(
              adminsField.fields,
              `${keyPre}last_version__`,
              '最新版本-',
            ),
            ...admins_fields,
          };
        } else if (adminsField.type == 'last_version') {
          admins_fields[`${keyPre}last_version__${adminsFieldKey}`] = {
            ...adminsField,
            label: `${labelPre}最新版本-${adminsField.label}`,
            showOnly: true,
          };
        } else {
          admins_fields[`${keyPre}admin__${adminsFieldKey}`] = {
            ...adminsField,
            label: `${labelPre}${adminsField.label}`,
            showOnly: true,
          };
        }
      }
      return admins_fields;
    },
    $_CMS_getUserFields(userFields, keyPre = '', labelPre = '') {
      let user_fields = {};
      for (let userFieldKey in userFields) {
        const userField = userFields[userFieldKey];
        if (userField.type == 'locales') {
          user_fields = {
            ...this.$_CMS_getLocalesFields(
              userField.fields,
              `${keyPre}last_version__`,
              '最新版本-',
            ),
            ...user_fields,
          };
        } else if (userField.type == 'last_version') {
          user_fields[`${keyPre}last_version__${userFieldKey}`] = {
            ...userField,
            label: `${labelPre}最新版本-${userField.label}`,
            showOnly: true,
          };
        } else {
          user_fields[`${keyPre}user__${userFieldKey}`] = {
            ...userField,
            label: `${labelPre}${userField.label}`,
            showOnly: true,
          };
        }
      }
      return user_fields;
    },
    $_CMS_getLocalesFields(localesFields, keyPre = '', labelPre = '') {
      let locales_fields = {};
      for (let localesFieldKey in localesFields) {
        const localesField = localesFields[localesFieldKey];
        locales_fields[`${keyPre}locales_main__${localesFieldKey}`] = {
          ...localesField,
          label: `主語言-${labelPre}${localesField.label}`,
          showOnly: true,
        };
        const tarLocale = this.$store.state.locale.locales.find((e) => {
          return e.code == this.$store.state.locale.selectingLocale;
        });
        locales_fields[
          `${keyPre}locales_${this.$store.state.locale.selectingLocale}__${localesFieldKey}`
        ] = {
          ...localesField,
          label: `${labelPre}${tarLocale.name}-${localesField.label}`,
          showOnly: true,
        };

        // locales.forEach(locale => {
        //   locales_fields[
        //     `${keyPre}locales_${locale.code}__${localesFieldKey}`
        //   ] = {
        //     ...localesField,
        //     label: `${labelPre}${locale.name}-${localesField.label}`,
        //     showOnly: true
        //   };
        // });
      }
      return locales_fields;
    },
    $_CMS_geUpdateFields(fields, updateHideFields) {
      let _fields = {};
      for (let fieldKey in fields) {
        if (updateHideFields && updateHideFields.includes(fieldKey)) {
          continue;
        }
        const field = fields[fieldKey];
        if (field.readonly) {
          continue;
        } else {
          _fields[fieldKey] = field;
        }
      }
      return _fields;
    },
    $_CMS_getDisplayFields(fields, updateHideFields) {
      let _fields = {};
      for (let fieldKey in fields) {
        if (updateHideFields && updateHideFields.includes(fieldKey)) {
          continue;
        }
        const field = fields[fieldKey];
        if (field.type == 'last_version') {
          _fields = {
            ...this.$_CMS_getVersionsFields(field.fields),
            ..._fields,
          };
        } else if (field.type == 'locales') {
          _fields = {
            ...this.$_CMS_getLocalesFields(field.fields),
            ..._fields,
          };
        } else if (field.type == 'payload') {
          _fields = {
            ...this.$_CMS_getPayloadsFields(field.fields),
            ..._fields,
          };
        } else if (field.type == 'factory') {
          _fields = {
            ...this.$_CMS_getFactorysFields(field.fields),
            ..._fields,
          };
        } else if (field.type == 'admin') {
          _fields = {
            ...this.$_CMS_getAdminsFields(field.fields),
            ..._fields,
          };
        } else {
          _fields[fieldKey] = field;
        }
      }
      return _fields;
    },
    // Get value from key in sequence string format
    $_CMS_getValueByFieldKey(fieldKey, valueItem) {
      const keyArr = fieldKey.split('.');
      let target = valueItem;
      for (let i = 0; i < keyArr.length; i++) {
        const keyItem = keyArr[i];
        let targetKey = keyItem;
        if (targetKey == 'locales' && keyArr.length > 1) {
          continue;
        }
        if (target[targetKey] !== undefined) {
          target = target[targetKey];
        } else {
          return null;
        }
      }

      if (keyArr[keyArr.length - 1] === 'locales' && keyArr.length > 1) {
        return (target = target[keyArr[keyArr.length - 1]]);
      }
      return target;
    },
    // Model update data set for v-model
    $_CMS_updateDataSetFromFields(template, updateData, fields, item) {
      for (let fieldKey in fields) {
        const field = fields[fieldKey];
        if (field.readonly) {
          continue;
        }
        let valueKey = fieldKey;
        if (item && item[valueKey] != undefined) {
          if (field.type == 'last_version' && item) {
            template.$set(updateData, fieldKey, item[valueKey]);
          } else if (field.type == 'belongsTo' && item) {
            template.$set(updateData, fieldKey, item[valueKey].id);
          } else if (field.type == 'hasMany' && item) {
            const _value = [];
            item[fieldKey].forEach((itemValueItem) => {
              _value.push(itemValueItem.id ? itemValueItem.id : itemValueItem);
            });
            template.$set(updateData, fieldKey, _value);
          } else if (field.type == 'multi-layer' && item) {
            if (field.multiple) {
              const _value = [];
              item[valueKey].forEach((itemValueItem) => {
                _value.push(itemValueItem.id);
              });
              template.$set(updateData, fieldKey, _value);
            } else {
              template.$set(updateData, fieldKey, item[valueKey].id);
            }
          } else if (field.type == 'text' && field.getText && field.disabled) {
            template.$set(updateData, fieldKey, field.getText(item[valueKey]));
          } else if (field.setUpdateData) {
            template.$set(updateData, fieldKey, field.setUpdateData(item[valueKey]));
          } else {
            template.$set(updateData, fieldKey, item[valueKey]);
          }
        } else if (field.defaultValue !== undefined) {
          template.$set(updateData, fieldKey, field.defaultValue);
          continue;
        } else {
          template.$set(updateData, fieldKey, null);
        }
      }
    },
    $_CMS_getTextFromLocales({locales, TextKey='name' ,defaultVal}) {
      const _selectingLocale = this.$store.state.locale.selectingLocale;
      return locales[_selectingLocale] && locales[_selectingLocale][TextKey]
        ? locales[_selectingLocale][TextKey]
        : defaultVal;
    },
  },
  computed: {
    _CMS_theme() {
      return vuetify.userPreset.theme.dark ? 'dark' : 'light';
    },
    _CMS_mainScope() {
      if (
        !this.$store.state.user.currentUser ||
        !this.$store.state.user.currentUser.scopes ||
        !this.$store.state.user.currentUser.scopes.length
      ) {
        return null;
      }
      if (!this.SET_scopes) {
        return null;
      }
      const tarScope = this.SET_scopes.find((scope) => {
        return this.$store.state.user.currentUser.scopes.includes(scope);
      });
      return tarScope;
    },
    _CMS_menu() {
      let tarMenu;
      if (!this.SET_menuByScopes) {
        tarMenu = this.SET_menu;
      } else if (!this.SET_menu[this._CMS_mainScope]) {
        tarMenu = [];
      } else {
        tarMenu = this.SET_menu[this._CMS_mainScope];
      }
      let _CMS_menu = [
        ...tarMenu,
        {
          icon: 'mdi-logout-variant',
          title: '登出',
          link: '/signout',
        },
      ];
      return _CMS_menu;
    },
  },
};
